module.exports = __webpack_public_path__ + "static/media/logo_kienlongbank.c167aa72.svg";